import type { ReactNode } from 'react';

import { cn } from '@/lib/utils';

interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  accessory?: ReactNode;
  actions?: ReactNode;
  className?: string;
  titleRowClassName?: string;
  subtitleClassName?: string;
}

export function PageHeader({
  title,
  subtitle,
  accessory,
  actions,
  className,
  titleRowClassName,
  subtitleClassName,
}: PageHeaderProps) {
  return (
    <div className={cn('flex flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-start sm:justify-between', className)}>
      <div className="min-w-0 flex-1">
        <div className={cn('flex flex-wrap items-center gap-x-3 gap-y-2', titleRowClassName)}>
          <h1 className="font-heading text-3xl font-bold">{title}</h1>
          {accessory}
        </div>
        {subtitle ? (
          <p className={cn('mt-1 text-muted-foreground', subtitleClassName)}>
            {subtitle}
          </p>
        ) : null}
      </div>

      {actions ? <div className="flex w-full shrink-0 items-center gap-2 sm:w-auto sm:max-w-full">{actions}</div> : null}
    </div>
  );
}
